import { useAppSelector } from "@/shared/lib/redux"
import { selectPartnerDiscountAggregates } from "../../model"
import { useMemo } from "react"
import { ChartBlock } from "@/shared/ui/chart-block"
import { selectBonuses } from "@/entities/bonus"

export const SumDiscounts = () => {
    const bonuses = useAppSelector(selectBonuses)
    const aggregates = useAppSelector(selectPartnerDiscountAggregates)

    const data = useMemo(() => {
        const parsed = bonuses
            .map((bonus) => ({
                bonus: bonus,
                data: aggregates[bonus.id]?.totalBonusTransactions
            }))
            .filter((exists) => exists.data ?? 0)
        const labels = parsed.map(obj => obj.bonus.name)
        const data = parsed.map(obj => obj.data)
        return {
            labels,
            datasets: [{
                data
            }]
        }
            
    }, [bonuses, aggregates])

    return (
        <ChartBlock 
            chartClass="min-h-[284px] h-[1px]" 
            type="doughnut" 
            title="Сумма бонусных скидок" 
            data={data}
            noData={!Boolean(data.datasets[0].data)}
            noDataComponent={
                <div className="flex h-full items-center justify-center">
                    <div className="text-xl screen:text-2xl mb-10 font-mediumttf text-white bg-color-secondary rounded-2xl p-4 text-center">
                        НЕДОСТАТОЧНО ДАННЫХ <br />
                        ДЛЯ ФОРМИРОВАНИЯ <br />
                        СТАТИСТИКИ
                    </div>
                </div>
            }
        />
    )
}